/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Col_ChangesInputs */

const cs_gdpr_col_changes = /** @type {(inputs: Gdpr_Col_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny (před → po)`)
};

const en_gdpr_col_changes = /** @type {(inputs: Gdpr_Col_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes (before → after)`)
};

/**
* | output |
* | --- |
* | "Changes (before → after)" |
*
* @param {Gdpr_Col_ChangesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_col_changes = /** @type {((inputs?: Gdpr_Col_ChangesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Col_ChangesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_col_changes(inputs)
	return cs_gdpr_col_changes(inputs)
});